import {
  AmazonHoverTrianglePoint,
  useAmazonHoverTriangle,
} from "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/AmazonHoverTriangle/__internal__/useAmazonHoverTriangle";
import { RefObject, useCallback } from "react";

export enum AmazonHoverTriangleTrackerDropdownDirection {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
}

export const useAmazonHoverTriangleTracker = <T extends Element>(
  ref: RefObject<T | null>,
  onMouseMoveOutsideTriangle: () => void,
  dropdownDirection: AmazonHoverTriangleTrackerDropdownDirection
) => {
  const { points, setTriangle, isPointInsideTriangle } =
    useAmazonHoverTriangle();

  const onMouseMove = useCallback(
    (event: React.MouseEvent) => {
      const point: AmazonHoverTrianglePoint = {
        x: event.clientX,
        y: event.clientY,
      };

      if (points && !isPointInsideTriangle(point)) {
        onMouseMoveOutsideTriangle();
      }

      const contentBound = ref.current?.getBoundingClientRect();
      if (contentBound) {
        const { left, right, top, bottom } = contentBound;
        const pointA: AmazonHoverTrianglePoint = {
          x:
            dropdownDirection ===
            AmazonHoverTriangleTrackerDropdownDirection.LEFT
              ? right
              : left,
          y:
            dropdownDirection ===
            AmazonHoverTriangleTrackerDropdownDirection.TOP
              ? bottom
              : top,
        };
        const pointB: AmazonHoverTrianglePoint = {
          x:
            dropdownDirection ===
            AmazonHoverTriangleTrackerDropdownDirection.RIGHT
              ? left
              : right,
          y:
            dropdownDirection ===
            AmazonHoverTriangleTrackerDropdownDirection.BOTTOM
              ? top
              : bottom,
        };
        setTriangle(point, pointA, pointB);
      }
    },
    [
      dropdownDirection,
      isPointInsideTriangle,
      onMouseMoveOutsideTriangle,
      points,
      ref,
      setTriangle,
    ]
  );

  return { onMouseMove };
};
